import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-configuration',
    standalone: true,
    imports: [ButtonModule, RouterModule],
    templateUrl: './configuration.component.html',
    styleUrl: './configuration.component.less',
})
export class ConfigurationComponent {
    isHome: boolean = true;
    constructor(private router: Router) {}
    goToDetail() {
        this.router.navigate(['/configuration/detail']);
    }
}
